import axios, { type AxiosStatic } from 'axios'
import { DOMAIN_API } from '../constants';
import { Attendance, AttendanceVerifyReq } from 'iasma-datatypes';

const URL_API = DOMAIN_API + '/api/event';

	
export async function getConfirmation(eventId: number) {
	const response = await axios.get(`${URL_API}/confirmation/${eventId}`);
	return response.data;
}

export async function setConfirmation(confirmation: Attendance) {
	const response = await axios.post(`${URL_API}/confirmation`, confirmation);
	return response.data;
}

export async function queryConfirmationSummary(eventId: number) {
	const response = await axios.get(`${URL_API}/chart-confirmation/${eventId}`);
	return response.data;
}

export async function queryConfirmationNames(eventId: number, angkatan: number) {
	const response = await axios.get(`${URL_API}/chart-confirmation/${eventId}/${angkatan}`);
	return response.data;
}

export async function createAttendance(eventId: number) {
	const response = await axios.post(`${URL_API}/attendance/${eventId}`, {});
	return response.data;
}

export async function checkAttendance(eventId: number) {
	const response = await axios.get(`${URL_API}/attendance/${eventId}`);
	return response.data;
}

export async function verifyAttendance(eventId: number, data: AttendanceVerifyReq) {
	const response = await axios.post(`${URL_API}/attendance/${eventId}/verify`, data);
	return response.data;
}

export async function manualAttendance(eventId: number, data: any) {
	const response = await axios.post(`${URL_API}/attendance/${eventId}/manual`, data);
	return response.data;
}

export async function queryPresentionSummary(eventId: number) {
	const response = await axios.get(`${URL_API}/chart/presention/${eventId}`);
	return response.data;
}

export async function queryPresentionNames(eventId: number, angkatan: number) {
	const response = await axios.get(`${URL_API}/chart/presention/${eventId}/${angkatan}`);
	return response.data;
}

export async function queryEvent(eventId: number) {
	const response = await axios.get(`${URL_API}/info/${eventId}`);
	return response.data;
}

